// get country jsons from https://stefangabos.github.io/world_countries/

export const transformCountries = countries =>
  countries.reduce((res, country) => ({
    ...res,
    [country.alpha2]: country.name
  }), {})
